module.exports = __webpack_public_path__ + "static/img/Bachelor_010193.a708616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010193.jpg
// module id = 120
// module chunks = 0